import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgToolNotepad = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17.25 10.5a.75.75 0 0 1-.75.75h-6a.75.75 0 1 1 0-1.5h6a.75.75 0 0 1 .75.75Zm-.75 2.25h-6a.75.75 0 1 0 0 1.5h6a.75.75 0 0 0 0-1.5ZM21 4.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 19.5v-15A1.5 1.5 0 0 1 4.5 3h15A1.5 1.5 0 0 1 21 4.5Zm-16.5 15h2.25v-15H4.5v15Zm15 0v-15H8.25v15H19.5Z",
		fill: "currentColor"
	})
});
export default SvgToolNotepad;
